import styled from "styled-components"

export const TermsAndConditionsWrapper = styled.div`
  display: inline-flex;
  ${({theme}) => `margin: ${theme.spacing.two} 0 0 -${theme.spacing.two};`}
`
